// extracted by mini-css-extract-plugin
export default {"centerSpinCon":"centerSpinCon--Lu6bq","markerAnimationScale":"markerAnimationScale--EW7mL"};